import { render, staticRenderFns } from "./EditarSala.vue?vue&type=template&id=5d4c7c2b&"
import script from "./EditarSala.vue?vue&type=script&lang=js&"
export * from "./EditarSala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports